/**
 * Thrown whenever the feature-flag configuration is invalid.
 *
 * Feature flags decide which trading verticals exist, so a misconfiguration is
 * never silently repaired: the app fails loudly at boot rather than rendering a
 * vertical the operator did not intend, or hiding one they did.
 */
export class FeatureFlagConfigError extends Error {
  constructor(message: string) {
    super(`[FeatureFlags] ${message}`);
    this.name = "FeatureFlagConfigError";
    // Required for `instanceof` to work when targeting ES5 (tsconfig target).
    Object.setPrototypeOf(this, FeatureFlagConfigError.prototype);
  }
}
